import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { MapPin, Megaphone, Check } from "lucide-react";
import { photoSrc } from "@/components/RoomPhotosUploader";

export default function ApplyPage() {
  const { id } = useParams();
  const { user } = useAuth();
  const [call, setCall] = useState(null);
  const [message, setMessage] = useState("");
  const load = () => { api.get(`/calls/${id}`).then((r) => setCall(r.data)).catch(() => setCall(false)); };
  useEffect(load, [id, user?.id]);

  const apply = async () => {
    try { await api.post(`/calls/${id}/apply`, { message }); toast.success("Candidature envoyée à la salle !"); setMessage(""); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  if (call === false) return <div><Navbar /><div className="p-10 text-slate-500">Appel à candidatures introuvable.</div></div>;
  if (!call) return <div><Navbar /><div className="p-10 text-slate-500">Chargement…</div></div>;
  return (
    <div>
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sc-fade-in" data-testid="apply-page">
        <div className="flex gap-4 items-start">
          {call.room?.photo_url && <img src={photoSrc(call.room.photo_url)} alt="" className="w-28 h-28 rounded-2xl object-cover" />}
          <div>
            <div className="text-xs uppercase tracking-widest font-bold text-indigo-600 flex items-center gap-1"><Megaphone className="w-3.5 h-3.5" /> Appel à candidatures {call.open ? "" : "· fermé"}</div>
            <h1 className="text-3xl font-extrabold text-slate-900 mt-1" data-testid="call-title-public">{call.title}</h1>
            <Link to={`/vitrine/${call.room?.id}`} className="text-sm text-slate-600 flex items-center gap-1 mt-1 hover:underline"><MapPin className="w-4 h-4" />{call.room?.name} · {call.room?.neighborhood} · {call.room?.city} · {call.room?.price_per_hour} €/h</Link>
            <div className="mt-2 flex flex-wrap gap-1.5">{(call.disciplines || []).map((d) => <span key={d} className="text-xs px-2 py-0.5 rounded-full bg-orange-500/10 text-orange-700 border border-orange-500/20">{d}</span>)}</div>
          </div>
        </div>
        <p className="mt-6 text-slate-700 whitespace-pre-line">{call.description}</p>
        <div className="mt-2 text-xs text-slate-500">{call.applications_count} candidature(s) reçue(s)</div>
        <div className="mt-8 sc-card">
          {!call.open ? <div className="text-slate-500 text-sm">Cet appel est fermé.</div>
            : !user || user === false ? <Link data-testid="apply-login" to={`/inscription?next=/postuler/${id}`} className="sc-btn sc-btn-primary">Créer mon compte coach pour postuler</Link>
            : user.role !== "coach" ? <div className="text-slate-500 text-sm">Seuls les comptes coach peuvent postuler.</div>
            : call.already_applied ? <div data-testid="apply-done" className="text-emerald-700 font-semibold flex items-center gap-2"><Check className="w-5 h-5" /> Candidature envoyée — la salle vous répondra par notification et email.</div>
            : (<>
              <div className="font-bold text-slate-900">Postuler</div>
              <textarea data-testid="apply-message" className="mt-2 w-full border border-slate-200 rounded-xl p-3 text-sm" rows={4} maxLength={1000} placeholder="Présentez-vous : expérience, disciplines, disponibilités…" value={message} onChange={(e) => setMessage(e.target.value)} />
              <button data-testid="apply-submit" onClick={apply} disabled={!message.trim()} className="mt-3 sc-btn sc-btn-emerald disabled:opacity-50">Envoyer ma candidature</button>
            </>)}
        </div>
      </div>
      <Footer />
    </div>
  );
}
